// extracted by mini-css-extract-plugin
export default {"sidebarTitle":"layout_sidebarTitle__zQ4XI","breadcrumb":"layout_breadcrumb__2Pwrt","breadcrumbItem":"layout_breadcrumbItem__RSVP8","breadcrumbSpan":"layout_breadcrumbSpan__Tmmnl"};